import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { geoJsonDataForSpot, priceInDollars } from './../../utils';

class SpotToRemove extends Component {

  render() {
    const {spotName} = this.props;
    const spotDetails = geoJsonDataForSpot(spotName);
    const {location, size, surface, price} = spotDetails.properties;

    return (
        <div>
          <div className="panel panel-spot panel-remove">
          <div className="panel-body">
            <h5 className="h6"><div className="icon-marker-pin pull-left" />
              {`${location} ${spotName}`}
            </h5>
            <span className="text-capitalize">{surface}</span> { size.trim() ? `- ${size}` : ''}
            <br />
            <span className="color-danger">
                <i className="fa fa-minus-circle"/>
                &nbsp;Will be removed<
            /span>
            <span className="pull-right st color-light">{ priceInDollars(price) }</span>
            </div>
          </div>
          <hr/>
      </div>
    );
  }
}

export default SpotToRemove;



// WEBPACK FOOTER //
// ./src/containers/checkout/SpotToRemove.js